import React from 'react';

type Props = {
    span: number
    children: React.ReactNode
}

function DescriptionListItem(props: Props) {
    return (
        <div className={props.span === 1? 'sm:col-span-1' : 'sm:col-span-2'}>
            {props.children}
        </div>
    );
}

DescriptionListItem.defaultProps = {
    span: 1
}

export default DescriptionListItem;